var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllAgesGeneral({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 126.40613,
    height: 126.406,
    viewBox: "0 0 126.40613 126.406",
    sodipodidocname: "All Ages-Genral.ai",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,94.805 H 94.805 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapegroupmode: "layer",
    inkscapelabel: "All Ages-Genral",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,126.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(85.918,34.1104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.811,-1.816 -4.21,-2.833 -6.781,-2.873 0.107,-0.813 0.216,-1.622 0.326,-2.42 0.125,-0.905 0.25,-1.811 0.371,-2.716 l 0.098,-0.727 c 0.108,-0.803 0.216,-1.606 0.313,-2.41 0.304,-2.549 -1.537,-4.959 -4.106,-5.373 -0.261,-0.042 -0.528,-0.063 -0.795,-0.063 -2.373,0 -4.384,1.65 -4.781,3.923 -0.188,1.072 -0.329,2.147 -0.467,3.195 -0.058,0.436 -0.116,0.873 -0.176,1.31 l -0.046,0.331 -2.012,-0.38 c 0.128,-0.264 0.255,-0.528 0.382,-0.791 0.752,-1.566 0.715,-3.281 -0.105,-4.83 -0.905,-1.709 -2.505,-2.698 -4.392,-2.715 -1.729,-0.015 -2.917,-0.022 -4.125,-0.022 -1.208,0 -2.436,0.007 -4.245,0.019 -2.7,0.018 -4.982,2.264 -5.087,5.006 -0.11,2.852 2.023,5.292 4.754,5.438 0.059,0.003 0.116,0.006 0.17,0.009 l -0.218,0.451 c -0.939,1.946 -1.03,4.052 -0.258,5.93 0.761,1.85 2.277,3.258 4.269,3.964 3.285,1.164 6.343,2.184 9.349,3.119 0.283,0.087 0.574,0.159 0.873,0.214 0.163,2.35 1.158,4.537 2.843,6.22 1.849,1.846 4.307,2.863 6.922,2.863 h 0.011 0.001 0.001 C -1.538,16.665 2.842,12.293 2.853,6.926 2.857,4.31 1.844,1.851 0,0 m -41.219,1.215 c -0.345,-0.056 -0.695,-0.084 -1.04,-0.084 -0.961,0 -2.325,0.228 -3.739,1.214 10e-4,-3.556 -0.001,-4.491 -0.024,-8.619 -0.005,-0.926 -0.15,-2.309 -0.814,-3.64 -1.118,-2.243 -3.376,-3.636 -5.891,-3.636 -0.522,0 -1.043,0.062 -1.547,0.186 -1.214,0.298 -2.296,0.873 -3.159,1.676 -1.252,-1.218 -2.887,-1.883 -4.659,-1.883 -3.829,0.01 -6.722,3.063 -6.73,7.1 -0.007,4.195 -0.007,5.137 -0.006,8.846 -1.134,-0.829 -2.431,-1.264 -3.792,-1.264 -1.748,0 -3.458,0.744 -4.815,2.095 -2.563,2.552 -2.675,6.682 -0.248,9.206 2.498,2.6 5.156,5.255 7.898,7.892 0.87,0.837 1.841,1.501 2.893,1.98 -1.483,2.014 -2.297,4.497 -2.304,7.066 -0.017,6.485 5.293,11.78 11.839,11.804 h 0.04 c 3.052,0 5.955,-1.219 8.173,-3.433 2.256,-2.251 3.495,-5.212 3.49,-8.338 -0.004,-2.57 -0.815,-5.056 -2.295,-7.074 1.18,-0.528 2.297,-1.303 3.326,-2.311 2.398,-2.347 4.768,-4.767 7.06,-7.108 2.036,-2.079 2.663,-4.761 1.72,-7.358 -0.858,-2.363 -2.767,-3.896 -5.376,-4.317 m 4.882,42.269 c 0.893,3.413 3.457,6.038 6.86,7.024 0.897,0.26 1.824,0.392 2.757,0.392 v 0 c 1.923,0 3.793,-0.556 5.407,-1.608 2.417,-1.575 4.024,-4.119 4.409,-6.98 0.413,-3.08 -0.458,-5.812 -2.598,-8.134 0.918,-3.27 1.522,-6.267 1.845,-9.156 0.324,-2.897 -0.268,-5.223 -1.809,-7.111 -1.129,-1.382 -2.722,-2.294 -4.737,-2.709 -0.585,-0.121 -1.163,-0.166 -1.732,-0.212 l -0.051,-0.004 c -0.218,-0.017 -0.437,-0.034 -0.682,-0.059 l -0.042,-0.003 h -0.019 l -0.209,-0.002 c -2.481,0 -4.626,0.767 -6.374,2.279 -1.466,1.269 -2.047,2.991 -2.357,4.176 -0.394,1.511 -0.266,2.966 -0.068,4.314 0.447,3.053 1.027,5.828 1.772,8.477 -2.358,2.517 -3.245,5.981 -2.372,9.316 m 20.704,11.311 c -22.922,12.638 -51.749,4.301 -64.386,-18.621 -12.638,-22.922 -4.301,-51.748 18.621,-64.386 22.922,-12.637 51.748,-4.3 64.386,18.622 12.637,22.921 4.3,51.748 -18.621,64.385",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(28.491,54.9025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 0.015 V 0 C 4.868,0.008 8.534,3.703 8.542,8.597 8.546,10.856 7.643,13.003 6.001,14.642 4.392,16.248 2.3,17.132 0.11,17.132 H 0.08 C -4.684,17.114 -8.551,13.272 -8.538,8.567 -8.526,3.76 -4.776,0 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(39.0345,51.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -1.22,1.194 -2.651,2.024 -4.351,2.195 -6.114,1.045 -8.227,0.376 -10.524,0.372 h -0.02 c -2.305,0 -4.425,0.668 -6.193,1.818 -1.509,-0.171 -2.829,-0.85 -3.925,-1.904 -2.652,-2.55 -5.259,-5.15 -7.809,-7.802 -1.25,-1.301 -1.081,-3.404 0.199,-4.678 0.764,-0.76 1.652,-1.154 2.536,-1.154 0.772,0 1.541,0.3 2.222,0.917 1.345,1.219 2.594,2.545 3.895,3.813 0.232,0.225 0.514,0.398 0.907,0.699 0,-6.841 -0.008,-9.605 0.005,-16.236 0.004,-2.248 1.497,-3.87 3.507,-3.875 0.003,0 0.007,0 0.01,0 1.995,0 3.546,1.654 3.562,3.841 0.017,2.317 0.011,4.635 10e-4,6.952 -0.004,0.786 0.109,1.576 1.054,1.597 0.015,0 0.029,0 0.043,0 1,0 1.103,-0.814 1.098,-1.643 -0.013,-2.408 -0.035,-4.817 0.009,-7.224 0.031,-1.708 1.145,-3.003 2.801,-3.409 0.257,-0.063 0.518,-0.093 0.778,-0.093 1.214,0 2.411,0.665 3.001,1.848 0.327,0.657 0.47,1.471 0.474,2.215 0.035,6.538 0.02,9.21 0.02,15.748 0.162,0.117 0.324,0.234 0.486,0.351 1.279,-1.403 2.53,-2.833 3.846,-4.2 0.727,-0.755 1.593,-1.281 2.642,-1.281 0.17,0 0.345,0.014 0.525,0.043 1.353,0.218 2.379,0.923 2.854,2.23 C 8.557,-9.53 8.112,-8.184 7.012,-7.06 4.691,-4.69 2.37,-2.32 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(79.0025,47.5282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -0.009 c -1.746,0 -3.388,-0.679 -4.623,-1.912 -1.232,-1.23 -1.911,-2.864 -1.911,-4.602 -10e-4,-1.738 0.679,-3.375 1.915,-4.609 1.237,-1.237 2.864,-1.912 4.624,-1.915 1.745,0.002 3.384,0.683 4.615,1.918 1.23,1.234 1.906,2.875 1.903,4.621 C 6.507,-2.92 3.585,-0.005 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(76.707,24.9382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -0.099,0.731 c -0.12,0.902 -0.244,1.803 -0.368,2.704 -0.205,1.483 -0.409,3.005 -0.601,4.525 -1.055,0.436 -2.025,1.08 -2.858,1.912 -1.07,1.069 -1.825,2.365 -2.23,3.776 -0.409,-0.016 -0.82,-0.081 -1.229,-0.208 -2.968,-0.923 -5.987,-1.93 -9.228,-3.079 -1.109,-0.393 -1.942,-1.151 -2.347,-2.135 -0.416,-1.011 -0.352,-2.175 0.18,-3.277 l 1.497,-3.1 c 0.038,-0.079 0.074,-0.163 0.117,-0.263 l 0.744,-1.71 h -2.164 c -0.594,-0.004 -0.929,-0.001 -1.18,0.002 -0.471,0.005 -0.614,0.006 -1.724,-0.053 -0.966,-0.052 -1.717,-0.978 -1.676,-2.064 0.039,-1.011 0.89,-1.87 1.858,-1.877 3.597,-0.024 4.884,-0.027 8.32,0.003 0.692,0.006 1.197,0.328 1.544,0.984 0.343,0.648 0.359,1.251 0.048,1.898 -0.362,0.754 -0.73,1.505 -1.103,2.269 l -1.14,2.336 9.56,1.807 0.515,-3.714 c 0.062,-0.447 0.121,-0.895 0.18,-1.343 0.132,-1.006 0.269,-2.046 0.445,-3.05 0.141,-0.808 0.974,-1.349 1.854,-1.208 0.853,0.138 1.49,0.95 1.392,1.773 C 0.212,-1.573 0.106,-0.787 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(57.3456,65.9691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.096,0.107 -0.141,0.12 -0.143,0.121 -1.07,0.346 -1.916,0.678 -2.716,1.134 -2.718,1.126 -2.72,1.118 -2.722,1.111 c -0.648,-2.326 -1.15,-4.73 -1.537,-7.349 -0.148,-0.994 -0.314,-2.121 -0.091,-3.217 0.433,-2.134 1.497,-3.465 3.252,-4.07 2.031,-0.701 4.044,-0.684 5.983,0.048 1.653,0.623 2.664,1.792 3.005,3.473 0.017,0.082 -0.007,0.215 -0.049,0.273 C 5.43,-6.386 2.792,-3.112 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42",
    transform: "translate(60.2577,65.9561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 5.01,-6.142 C 4.648,-3.673 4.146,-1.275 3.483,1.149 2.385,0.527 1.239,0.149 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(63.5411,80.5556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.45,0.383 -1.821,1.557 -4.803,1.433 -1.808,-0.071 -3.58,-0.998 -4.863,-2.545 -1.331,-1.605 -1.934,-3.608 -1.654,-5.497 0.27,-1.823 1.256,-3.442 2.777,-4.559 1.512,-1.111 3.342,-1.565 5.151,-1.279 2.99,0.472 4.987,2.231 5.775,5.088 C 3.172,-4.494 2.37,-2.018 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllAgesGeneral);
export default __webpack_public_path__ + "static/media/all_ages_general.7e7130d07183085b9312637161972104.svg";
export { ForwardRef as ReactComponent };